// extracted by mini-css-extract-plugin
export default {"container":"style_container__nBTh7","header":"style_header__4MJXS"};